import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mr-footer',
  template: require('./mr-footer.html'),
})
export class MRFooterComponent implements OnInit {
  public userInfo: any;
  busy!: Subscription;

  public unitInfo: any;
  static parameters = [
  ];
  constructor(
  ) {
    this.userInfo = JSON.parse(localStorage.getItem('user') as any);
    this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
  }


  ngOnInit() {}
 
}
